import React from "react";

const subTypeColors = [
    ["#56CCF2", "#BFECFA"],
    ["#F8F8F8", "#F8F8F8"],
    ["#EAEAEA", "#EAEAEA"],
]
const subtypeTextColorsTitle = [
    "white",
    "black",
    "black"
]
const subtypeTextWeight = [
    "bold",
    "normal",
    "normal"
]


export default class InGameValueCard extends React.Component {

    constructor(props) {
        super(props);
        this.value = 0;

        this.changeValue = ev => {
            this.value = this.props.selectData ? ev.target.selectedIndex : ev.target.value;
            if (this.props.onChange && this.props.valueType && this.props.valueType !== "text") {
                this.props.onChange(Number(this.value));
            } else {
                this.props.onChange(this.value)
            }
        }
    }

    render() {
        let card = "";
        let value = "";
        if (this.props.type === 0) {

            if (this.props.value || this.props.isEditable) {
                value = <div className="in-game-popup-card-type-one-right">
                    {this.props.isEditable ? <input className="in-game-popup-card-type-one-input"
                                                    type={this.props.valueType ?? "number"}
                                                    onChange={this.changeValue}
                        />
                        :
                        <div
                            className="in-game-popup-card-type-one-right-text">{this.props.value.toLocaleString()}</div>
                    }
                </div>;
            }
            card = <div
                className={"in-game-popup-card-type-one" + (this.props.className ? " " + this.props.className : "")}>
                <div className="in-game-popup-card-type-one-text">{this.props.title}</div>
                {value}
            </div>
        } else {
            let currentInputField = this.props.selectData ?
                <div className={this.props.hideButton ? "" : "select-wrapper"}><select
                    onChange={this.changeValue}>{this.props.selectData.map((el, i) => <option key={i}
                                                                                              value={el}>{el}</option>)}</select>
                </div> : <input type={this.props.valueType ?? "number"}
                                onChange={this.changeValue}
                                onInput={e => {
                                    if (e.target.type === "number" && this.props.maxValue !== undefined) {
                                        if (parseFloat(e.target.value) > this.props.maxValue)
                                            e.target.value = this.props.maxValue;
                                    }
                                    if (e.target.type === "number" && this.props.minValue !== undefined) {
                                        if (parseFloat(e.target.value) < this.props.minValue)
                                            e.target.value = this.props.minValue;
                                    }
                                }}
                                style={{
                                    fontSize: 12,
                                    paddingTop: "3px",
                                    paddingLeft: "0px",
                                    paddingRight: "0px",
                                    fontWeight: subtypeTextWeight[this.props.subtype],
                                    color: "black",
                                    border: this.props.border || 'none',
                                    background: subTypeColors[this.props.subtype][1],
                                    width: "112px"
                                }}/>;
            card = <div style={{
                display: "flex",
                justifyContent: "space-between",
                height: this.props.height,
                background: subTypeColors[this.props.subtype][0]
            }}>
                <div className={this.props.className || ""} style={
                    {
                        paddingLeft: "10px",
                        paddingTop: "4px",
                        fontSize: 10,

                        fontWeight: subtypeTextWeight[this.props.subtype],
                        color: subtypeTextColorsTitle[this.props.subtype],
                        textTransform: this.props.subtype === 0 ? "uppercase" : ""
                    }
                }>
                    {this.props.title}
                </div>
                <div className={"in-game-popup-card-type-one-right"} style={{
                    background: subTypeColors[this.props.subtype][1]
                }}>
                    {this.props.isEditable ?
                        (currentInputField ?? "Error")
                        : <div style={{
                            fontSize: 12,
                            paddingTop: "3px",
                            fontWeight: subtypeTextWeight[this.props.subtype],
                            color: "black"
                        }}>
                            {(this.props.value ?? "Error").toLocaleString()}
                        </div>}
                </div>
            </div>
        }

        return card;
    }

}
